/**
 * API SCORM
 * https://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/#section-5
 *
 * messages et fonctions les plus utilisées
 * api.Initialize("")
 * api.setValue('cmi.suspend_data', json_string) // les données de sauvegarde stringifiées
 * api.setValue('cmi.completion_status', "not attempted|incomplete|completed")
 * api.setValue('cmi.progress_measure', 0.2) // entre 0 et 1
 * api.setValue("cmi.exit", "suspend"|"timeout"|"logout"|"normal") // a envoyer quand on quitte
 * api.Commit("") // a envoyer a
 * api.Terminate("") // à envoyer à la fin du jeu pour notifier le LMS qu'on a fini le module
 *
 */



export class FakeScormApi {
  onCommit = null
  onTerminate = null

  onSetValue = null

  showLog=false // modif ca si on veut du log

  constructor(module_id) {

    this.id = module_id

  }

  log() {
    if(!this.showLog) return

    console.log(arguments)
  }



  Initialize() {
    this.log("FakeScormApi: Initialize")
  }

  GetLastError() {
    this.log("FakeScormApi: GetLastError")

  }
  GetErrorString(errcode) {
    this.log("FakeScormApi: GetErrorString", errcode)

  }
  GetDiagnostic(errcode) {
    this.log("FakeScormApi: GetDiagnostic", errcode)
  }

  GetValue(name) {
    this.log("FakeScormApi: GetValue: ", name)
    return localStorage.getItem(this.id + "_" + name)
  }

  /**
   *
   * @param {String} name
   * @param {String} val
   */
  SetValue(name, val) {
    this.log("FakeScormApi: SetValue: ", name, val)
    if(this.onSetValue) this.onSetValue(name, val)
    localStorage.setItem(this.id + "_" + name, val)
  }
  Commit() {
    this.log("FakeScormApi: Commit")
    if(this.onCommit) this.onCommit()

  }
  Terminate() {
    this.log("FakeScormApi: Terminate")

    if(this.onTerminate) this.onTerminate()
  }
}



/** NOTE
 * ScormAdapter est a utiliser dans une appli qu'on veut héberger en tant que module SCORM qq part
 */

// https://scorm.com/scorm-explained/technical-scorm/run-time/
// In SCORM 1.1 and SCORM 1.2, the API object is always named “API”. In SCORM 2004, the object is named “API_1484_11”.
class ScormAdapter {

  api = null
  findAPITries = 0

  api_variable_name = ""

  constructor(useMockApi, api_variable_name="API_1484_11" ) {
    this.api_variable_name = api_variable_name
    let api = this.getAPI(useMockApi)

    this._onQuit = this._onQuit.bind(this)

    if(api) {
      try {
        this.api = new api()
        this.api.Initialize("")
      }
      catch(err) {
        // ce n'est pas un constructor, on peut utiliser direct la classe comme ça
        this.api = api
        this.api.Initialize("")
      }
    }
    else {
      console.error("Cound not find SCORM API")
    }

  }

  _onQuit() {
    this.terminate("suspend")
  }
  addQuitListener() {
    document.body.addEventListener("beforeunload", this._onQuit)
  }
  removeQuitListener() {
    document.body.removeEventListener("beforeunload", this._onQuit)
  }

  findAPI(win) {
    while ((win[this.api_variable_name] == null) && (win.parent != null) && (win.parent != win)) {
      this.findAPITries++;
      // Note: 7 is an arbitrary number, but should be more than sufficient
      if (this.findAPITries > 7)  {
        console.warn("Error finding API -- too deeply nested.");
        return null;
      }
      win = win.parent;
    }
    return win[this.api_variable_name];
  }
  getAPI(useMockApi) {
    if (useMockApi) {
      console.log("=== Using fake SCORM api ===");
      return FakeScormApi
    }
    var theAPI = this.findAPI(window);
    if ((theAPI == null) && (window.opener != null) && (typeof(window.opener) != "undefined")) {
      theAPI = this.findAPI(window.opener);
    }
    return theAPI
  }



  setValue(name, value) {
    if(!this.api) {
      console.warn("Unable to locate the LMS's API Implementation.\nGetValue was not successful.");
      return;
    }

    let result = this.api.SetValue(name, value);

    if(result == "false") {
      let errcode = this.api.GetLastError()
      let err_string = this.api.GetErrorString(errcode)
      let err_diag = this.api.GetDiagnostic(errcode)

      console.log("err", errcode, err_string)
      console.log("diag", err_diag)

      return false
    }
    // else {
    //   console.log("setValue returns:", result)
    // }

    return result
  }

  getValue(name) {
    if(!this.api) {
      console.warn("Unable to locate the LMS's API Implementation.\nGetValue was not successful.");
      return;
    }
    let result = this.api.GetValue(name);

    if(result == "") {
      return false
    }
    return result
  }

  /**
   *
   * @param {Object} data la data à save
   * @param {Number} progress chiffre entre 0 et 1
   * @returns
   */
  set_savegame(data, progress) {

    let isok = this.setValue('cmi.suspend_data', JSON.stringify(data))

    let completion_status = "not attempted"
    let success_status = "unknown"
    if(progress !== undefined) {

      if(progress === 1)  {
        completion_status = "completed"
        success_status = "passed"
      }
      else if (progress > 0) {
        completion_status = "incomplete"
      }
    }


    this.setValue('cmi.completion_status', completion_status)
    // this.setValue('cmi.success_status', success_status)
    this.setValue('cmi.progress_measure', progress)


    if(this.api) this.api.Commit("")
    return isok
  }

  get_savegame() {
    return this.getValue('cmi.suspend_data')
  }

  terminate(val) {
    this.removeQuitListener() // si on quitte avec le bouton "Quitter", on ne veut pas l'envoi auto de cmi.exit
    this.setValue("cmi.exit", val)
    if(this.api) {
      // console.log("calling terminate")
      let result = this.api.Terminate("")
      console.log("terminate result", result)
    }
  }

}

export default ScormAdapter